import { UiIconModel } from "../../models";

export function mockUiIconModel({
    id = "icon-1234",
    type = "uiIcon",
    locale = "en",
    content = mockUiIconModelContent()
}: Partial<UiIconModel> = {}): UiIconModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiIconModelContent = UiIconModel["content"];

export function mockUiIconModelContent({
    entryTitle = "Lorem ipsum",
    icon = "Box",
    ...optionals
}: Partial<UiIconModelContent> = {}): UiIconModelContent {
    return {
        entryTitle,
        icon,
        ...optionals
    };
}
